import {
  ReleaseFeatureIdentifiersByDate,
  ReleasedFeaturesInDate,
  ReleaseNotesService
} from "../../sdServices/release-notes-config/release-notes-service";
import { CustomKeyValues, TelemetryService } from "../../../ShellCommon/logger/telemetry-service";
import { GlobalTelemetryConstants } from "../../../ShellCommon/logger/telemetry-constants";
import * as ReleaseNotesTelemetryConstants from "../../Constants/ReleaseNotesTelemetryConstants";

export class SdDetailedReleaseNotesContoller {
  public currentReleaseFeatureIdentifier: ReleasedFeaturesInDate;
  public previousReleaseFeatureIdentifier: ReleasedFeaturesInDate;
  public releaseFeatureIdentifierByDate: ReleaseFeatureIdentifiersByDate;

  public readonly DATE_FORMAT: Intl.DateTimeFormatOptions = { month: "long", day: "numeric", year: "numeric" };
  public previousReleasesContainerPath: string;

  private readonly releaseNoteDetailList = "../ServiceDesk/releaseNotes/detail/sd-release-note-detail-list.html";
  private readonly releaseNoteDetailVersion = "../ServiceDesk/releaseNotes/detail/sd-release-note-detail-version.html";
  // @ngInject
  constructor(
    private releaseNotesService: ReleaseNotesService,
    private telemetryService: TelemetryService,
    private telemetryConstants: GlobalTelemetryConstants
  ) {}

  public $onInit(): void {
    this.previousReleasesContainerPath = this.releaseNoteDetailList;

    this.releaseNotesService
      .getAllActiveReleasedFeatureIdentifiersByDate()
      .then((releasedFeatures: ReleaseFeatureIdentifiersByDate) => {
        this.releaseFeatureIdentifierByDate = releasedFeatures;
        this.currentReleaseFeatureIdentifier = releasedFeatures[0];
      });
  }

  // for telemetry: logs how far back in date the user toggled the expand on the release note in the list
  public onDateExpandCallback(releaseFeatureIdentifier: ReleasedFeaturesInDate, expanded: boolean) {
    const metaTags: CustomKeyValues = {};
    metaTags[this.telemetryConstants.pageMetadataTags.scenario] =
      ReleaseNotesTelemetryConstants.RELEASE_NOTES_TELEMETRY_APP_ID +
      "." +
      ReleaseNotesTelemetryConstants.RELEASE_NOTES_TELEMETRY_SCENARIO.FULL;
    metaTags[this.telemetryConstants.pageMetadataTags.scenarioStep] =
      ReleaseNotesTelemetryConstants.RELEASE_NOTES_TELEMETRY_APP_ID +
      "." +
      ReleaseNotesTelemetryConstants.RELEASE_NOTES_TELEMETRY_SCENARIO.FULL +
      "." +
      ReleaseNotesTelemetryConstants.RELEASE_NOTES_TELEMETRY_SCENARIO_STEP.TOGGLE_SPLASH_PREVIOUS_RELEASE;
    let data: CustomKeyValues = {};
    data["versionToggleExpandTime"] = String(new Date());
    data["version"] = String(releaseFeatureIdentifier.date);

    this.telemetryService.pushPageActionEvent(
      this.telemetryConstants.pageActionType.click,
      expanded ? this.telemetryConstants.pageActionBehavior.Expand : this.telemetryConstants.pageActionBehavior.Reduce,
      metaTags,
      data
    );
  }

  public onDateSelect(releaseFeatureIdentifier: ReleasedFeaturesInDate): void {
    this.previousReleaseFeatureIdentifier = releaseFeatureIdentifier;
    this.previousReleasesContainerPath = this.releaseNoteDetailVersion;
    const metaTags: CustomKeyValues = {};
    metaTags[this.telemetryConstants.pageMetadataTags.scenario] =
      ReleaseNotesTelemetryConstants.RELEASE_NOTES_TELEMETRY_APP_ID +
      "." +
      ReleaseNotesTelemetryConstants.RELEASE_NOTES_TELEMETRY_SCENARIO.FULL;
    metaTags[this.telemetryConstants.pageMetadataTags.scenarioStep] =
      ReleaseNotesTelemetryConstants.RELEASE_NOTES_TELEMETRY_APP_ID +
      "." +
      ReleaseNotesTelemetryConstants.RELEASE_NOTES_TELEMETRY_SCENARIO.FULL +
      "." +
      ReleaseNotesTelemetryConstants.RELEASE_NOTES_TELEMETRY_SCENARIO_STEP.OPEN_FULL_PREVIOUS_RELEASE;
    let data: CustomKeyValues = {};
    data["fullVersionSelectTime"] = String(new Date());
    data["version"] = String(releaseFeatureIdentifier.date);

    this.telemetryService.pushPageActionEvent(
      this.telemetryConstants.pageActionType.click,
      this.telemetryConstants.pageActionBehavior.Navigate,
      metaTags,
      data
    );
  }

  public backToList(): void {
    this.previousReleasesContainerPath = this.releaseNoteDetailList;
  }
}
export const sdDetailedReleaseNotes: ng.IComponentOptions = {
  controller: SdDetailedReleaseNotesContoller,
  templateUrl: "../ServiceDesk/releaseNotes/detail/sd-release-note-detail-container.html"
};
